import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const createRegisterAccess = api((domain) =>
    mutate(
        gql`
            mutation CreateRegisterAccess($domain: String!) {
                createRegisterAccess(domain: $domain)
            }
        `,
        { domain },
        { returns: "createRegisterAccess" }
    )
)
